import PropTypes from "prop-types";
import React from "react";

// Milestone times carry the venue's UTC offset; pin formatting to the venue tz so
// a late-day milestone shows the venue's calendar day, not the viewer's browser day.
const fmtDate = (iso, timeZone) =>
  iso
    ? new Date(iso).toLocaleString("en-US", {
        month: "short", day: "numeric", ...(timeZone ? { timeZone } : {}),
      })
    : "TBD";

const isPast = (iso) => iso && new Date(iso).getTime() < Date.now();

const dotState = (item, idx, activeIdx) => {
  if (!item.time) return "future";
  if (isPast(item.time)) return "past";
  return idx === activeIdx ? "active" : "future";
};

const EventTimelineCard = ({ timeline, timeZone }) => {
  // The next set-and-not-yet-passed milestone is the "active" one; an unset
  // milestone (no date) never counts as active.
  const activeIdx = timeline.findIndex((item) => item.time && !isPast(item.time));

  return (
  <div className="d2-card">
    <div className="d2-card-header">
      <span className="d2-card-title">Event Timeline</span>
      <a className="d2-card-link" href="#show_details">Show Details <i className="fas fa-arrow-right" style={{ fontSize: "10px" }} /></a>
    </div>

    {timeline.length > 0 && (
      <div className="d2-timeline">
        {timeline.map((item, idx) => (
          <div className="d2-tl-item" key={item.label}>
            <div className={`d2-tl-dot ${dotState(item, idx, activeIdx)}`} />
            <div className="d2-tl-label">{item.label}</div>
            <div className="d2-tl-date">{item.time ? fmtDate(item.time, timeZone) : ""}</div>
          </div>
        ))}
      </div>
    )}

    <div style={{ marginTop: "24px", paddingTop: "16px", borderTop: "1px solid var(--sl-border-secondary)" }}>
      <div style={{ fontSize: "12px", fontWeight: 600, color: "var(--sl-text-tertiary)", textTransform: "uppercase", letterSpacing: "0.3px", marginBottom: "12px" }}>Key Dates</div>

      {timeline.length === 0 ? (
        <div style={{ fontSize: "13px", color: "var(--sl-text-tertiary)" }}>No dates set.</div>
      ) : (
        timeline.map((item, idx) => {
          const notSet = !item.time;
          const done = isPast(item.time);
          return (
            <div
              key={item.label}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "8px 0",
                borderBottom: idx === timeline.length - 1 ? "none" : "1px solid var(--sl-border-secondary)",
              }}
            >
              <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: done ? "var(--sl-text-success)" : "var(--sl-text-brand)", flexShrink: 0 }} />
              <span style={{ flex: 1, fontSize: "13px" }}>{item.label}</span>
              <span style={{ fontSize: "13px", color: "var(--sl-text-tertiary)" }}>{notSet ? "" : fmtDate(item.time, timeZone)}</span>
              {notSet ? (
                <span className="d2-tl-pill is-notset">Date Not Set</span>
              ) : done ? (
                <span className="d2-tl-pill is-done">Done</span>
              ) : (
                <span className="d2-tl-pill is-upcoming">Upcoming</span>
              )}
            </div>
          );
        })
      )}
    </div>
  </div>
  );
};

EventTimelineCard.propTypes = {
  timeline: PropTypes.array.isRequired,
  timeZone: PropTypes.string,
};

export default EventTimelineCard;
